<template>
  <div class="caseStudyPage">
    <el-header>
      <!-- <Header></Header> -->
    </el-header>
    <el-main>
      <div class="main">
        <div class="page-left">
          <div class="user-card-container">
            <div style="text-align: left">
              <el-button @click="$router.go(-1)" size="mini" type="primary"
                >返回</el-button
              >
            </div>
            <UserCard
              ref="userCard"
              v-if="patientData.patientId && showComponent"
              :patientData="patientData"
            ></UserCard>
          </div>
          <div>
            <div style="width: 400px; margin-top: 10px">
              <el-tabs type="border-card">
                <el-tab-pane label="参考信息">
                  <referenceInformation
                    ref="referenceInfo"
                    v-if="patientData.patientId && showComponent"
                    :patientData="patientData"
                  ></referenceInformation>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
        <div class="page-center">
          <div v-if="audioList.length && showAudio" class="audio-container">
            <div class="select-bar">
              <el-select placeholder="请选择录音" @change="selectRecordChange" size="mini" v-model="selectAudioId">
                <el-option v-for="(item,index) in audioList" :key="index" :value="item.id"
                           :label="item.recordName"></el-option>
              </el-select>
            </div>
            <div class="audio-item">
              <audioPlayer v-if="showA" :src="audioSrc" @startPlayOrPause="startPlayOrPause" :key="timer"></audioPlayer>
            </div>
          </div>
          <div class="question-container">
            <question-new v-if="showComponent && patientData.isNewTask" :admitNo="patientData.admitNo"
                          :taskId="$route.query.taskId"></question-new>
            <question-tree-node :infoId="patientData.followUpPatientInfoId" :questionDisabled="true"
                                v-if="showComponent && patientData.followupPatientId && !patientData.isNewTask"
                                :patientId="patientData.followupPatientId" :taskId="$route.query.taskId"
                                ref="questionTreeNode"></question-tree-node>
          </div>
        </div>
        <div class="page-right"></div>
      </div>
    </el-main>
    <el-footer>
      <Footer></Footer>
    </el-footer>
  </div>
</template>

<script>
import {
  RestNewFollowupCallCenterServiceGetStudyById,
  RestNewFollowupCallCenterServiceGetFollowUpTaskAllSpotCheck,
  RestNewFollowupCallCenterServiceGetSeatsByTaskId,
  RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo,
  RestFeedbackOutControllerGetFollowUpTaskPatientCallRecordList,
  RestNewFollowupCallCenterServiceGetALiRecording,
  RestNewFollowupCallCenterServiceGetStudyListByTask,
} from '@src/assets/js/api.js'
import Header from '../common/Header'
import Footer from '../common/Footer'
import UserCard from '../patient/UserCard.vue'
import referenceInformation from '../referenceInformation/referenceInformation'

import questionNew from '../question_Third/question'
import questionTreeNode from '../questionPreview/question-root-node-new'
import audioPlayer from '../AudioPlayer/vueAplayerN'

import { mapGetters, mapMutations, mapState } from 'vuex'
export default {
  name: 'caseStudyPage',
  data() {
    return {
      patientData: {},
      showComponent: true,
      // 录音
      audioList: [],
      audioSrc: "",
      showAudio: true,
      showA: false,
      selectAudioId: null,
      timer: null,
    }
  },
  computed: {
    ...mapGetters([
      'userid',
      'patientId',
      'taskValue',
      'username',
      'getTaskCenterId',
    ]),
    ...mapState(['user']),
  },
  components: {
    Header,
    Footer,
    UserCard,
    referenceInformation,
    questionNew,
    questionTreeNode,
    audioPlayer,
  },
  mounted() {
    let vm = this
    vm.init()
  },
  methods: {
    init(){
      this.getPatientDetail()
      this.getRecordList()
    },
    getPatientDetail() {
      this.showAudio = false
      this.asyncGetNormalPatientInfo({
        userId: this.$route.query.seatId,
        followupPatientId: this.$route.query.fpId,
        taskId: this.$route.query.taskId,
      }).then((res) => {
        this.patientData = res.retValue
        this.showComponent = false
        setTimeout(() => {
          this.showComponent = true
        }, 100)
      })
    },
    getRecordList(){
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestBestFollowupCaseCallcenterControllerQueryBestRecordByCaseId',
          params: {caseId: this.$route.query.caseId}
        }
      ).then(res => {
        if (res.status == 0) {
          this.audioList = res.retValue
          this.audioSrc = ""
          this.showAudio = true
        } else {
          this.$message.error(res.desc)
        }
      })
    },
    selectRecordChange(){
      this.timer= new Date().getTime()
      let _address= this.audioList.find(item=> item.id == this.selectAudioId).contactAddress
      if (_address) {
        this.audioSrc = JSON.parse(_address)
        this.showA = true
      }else {
        this.showA = false
      }
      
    },
    startPlayOrPause(isPlaying){
      if (isPlaying) {
        this.$store.dispatch('requestHandler',
          {
            fn: 'RestBestFollowupCaseCallcenterControllerUpdateStatus',
            params: {
              caseId: this.$route.query.caseId,
              seatId: this.userid
            }
          }
        ).then(res => {
          if (res.status !== 0) {
            this.$message.error(res.desc)
          }
        })
      }
    },
    // =====================
    async asyncGetNormalPatientInfo(params) {
      let info =
        new RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo()
      info.p_userId = params.userId
      info.p_followupPatientId = params.followupPatientId || null
      info.p_followupTaskId = params.taskId || null
      await info.send()
      if (info.result.status == 0) {
        return info.result
      }
    },
    async getPatientRecordByPatientIdAsync(p) {
      let request = new RestFeedbackOutControllerGetFollowUpTaskPatientCallRecordList()
      request.p_followUpPatientInfoId = p.followUpPatientInfoId
      await request.send()
      return request.result
    },
  },
}
</script>
<style lang="scss" scoped>
$height: 1020px - 96px - 60px;
.caseStudyPage {
  width: 100vw;
  .el-main {
    //min-height: calc(100vh-96px-60px);
    width: 100%;
    // min-height: $height;
    margin: 0px;
    padding: 0px;
    height: calc(100vh - 120px);
    overflow: auto;
  }

  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }
  .page-left {
    padding: 15px;
  }
  .page-center {
    flex: 4;
    height: 793px;
    padding: 15px 0;
    .audio-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      /*border: 1px solid #ccc;*/
      border-radius: 5px;
      padding: 0 15px;
      margin-bottom: 15px;
      width: 100%;

      .select-bar {
        width: 20%;
      }

      .audio-item {
        width: 80%;
      }
    }
  }
  .page-right {
    flex: 3;
    width: 30%;
    padding: 15px 0;
    margin-left: 15px;
    text-align: left;
  }
}
</style>
